/** Inspection attribute for contract PDF Section 4 (Special Project Notes). */
export const PROJECT_NOTES_ATTRIBUTE = "Special Project Notes";

/** Matches inspection_attributes.AttributeValue varchar(255). */
export const PROJECT_NOTES_MAX_LENGTH = 255;

/** Default EST_* inspection attribute values (Excel cost.xlsx aligned) */
export const DEFAULT_ESTIMATING_VALUES: Record<string, string | number | boolean> = {
    [PROJECT_NOTES_ATTRIBUTE]: "",
    EST_PAYMENT_TYPE: "insurance",
    EST_WASTE_FACTOR: 10,
    EST_STEEP_RATE_7_9: "25.00",
    EST_STEEP_RATE_10_12: "45.00",
    EST_STEEP_RATE_13_PLUS: "75.00",
    EST_EXTRA_LAYER_RATE: "15.00",
    EST_DEDUCTIBLE: "",
    EST_OP_PERCENT: "20",
    EST_SALES_TAX_RATE: "7.5",
    EST_OVERHEAD_PERCENT: "3.25",
    EST_TARGET_MARGIN: "25",
    EST_SALESMAN_COMMISSION_PERCENT: "30",
    EST_CC_FEE_PERCENT: "3.0",
    EST_PERMIT_COST: "150.00",
    EST_DUMPSTER_FEE: "450.00",
    EST_EAGLEVIEW_COST: "75.00",
    EST_REFERRAL_FEE: "0",
    EST_TRIP_CHARGE: "0",
    EST_NO_ACCESS_FEE: "0",
    EST_JOB_PHOTOS_FEE: "100.00",
    EST_BID_AMOUNT: "",
    EST_BILLED_AMOUNT: "",
    EST_SHINGLE_UPGRADE_NOTES: "",
    EST_SHINGLE_UPGRADE_AMOUNT: "",
    EST_PAYMENT_TERMS: "Insurance claim — O&P 20%",
};

export const EST_NUMERIC_KEYS = new Set([
    "EST_WASTE_FACTOR",
    "EST_SALES_TAX_RATE",
    "EST_OVERHEAD_PERCENT",
    "EST_TARGET_MARGIN",
    "EST_SALESMAN_COMMISSION_PERCENT",
    "EST_CC_FEE_PERCENT",
    "EST_OP_PERCENT",
    "EST_SHINGLE_UPGRADE_AMOUNT",
]);
